import { cn } from '@/lib/cn';

// Minimal Tailwind badge primitive (TDS §13 — copy-paste from mvp adapted to
// the operator slate; no CSS-in-JS, no extra deps). Used by the case-workspace
// summary panels (filters, alerts, hotel status).

export type BadgeVariant =
  | 'muted'
  | 'secondary'
  | 'success'
  | 'warning'
  | 'error'
  | 'info'
  | 'neutral';
export type BadgeSize = 'sm' | 'md';

const VARIANT: Record<BadgeVariant, string> = {
  muted: 'bg-muted text-muted-foreground',
  secondary: 'bg-secondary text-secondary-foreground',
  neutral: 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300',
  success: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
  warning: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  error: 'bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-300',
  info: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300',
};

const SIZE: Record<BadgeSize, string> = {
  sm: 'px-1.5 py-0.5 text-[11px]',
  md: 'px-2 py-0.5 text-xs',
};

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  size?: BadgeSize;
}

export function Badge({ variant = 'muted', size = 'md', className, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-sm font-medium leading-none',
        VARIANT[variant],
        SIZE[size],
        className,
      )}
      {...props}
    />
  );
}
